import { render, staticRenderFns } from "./ModalSub.vue?vue&type=template&id=5fbd85cd&scoped=true"
import script from "./ModalSub.vue?vue&type=script&lang=js"
export * from "./ModalSub.vue?vue&type=script&lang=js"
import style0 from "./ModalSub.vue?vue&type=style&index=0&id=5fbd85cd&prod&lang=scss&scoped=true"
import style1 from "./ModalSub.vue?vue&type=style&index=1&id=5fbd85cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd85cd",
  null
  
)

export default component.exports